module.exports = __webpack_public_path__ + "media/images/lightbox/thumb-v-v-2-9cdaef4c1ed73d79f3d4ddfde639a8ba.jpg";